module.exports = __webpack_public_path__ + "assets/img/hzhb_ng.673cf4bf.png";